<template>
  <div class="w-screen min-h-screen flex items-center justify-center bg-gray-100">
    <div>
      <h1 v-if="!insideIframe" class="text-primary text-6xl font-normal mb-4">404</h1>
      <h2 class="pb-12 font-extrabold text-gray-600 text-center text-xl">
        <span v-if="insideIframe" class="text-primary mr-1">404</span>
        {{$t('404.not_found')}}
      </h2>
      <p class="text-center">
        <Button v-if="!insideIframe" class="mt-4" v-on:click.native="goBack()">
          {{$t('404.back')}}
        </Button>
        <Button v-else :href="airMapUrl" class="mb-4">
          {{$t('404.open_map')}}
        </Button>
      </p>
    </div>
  </div>
</template>

<script>
import { insideIframe } from '@/router';
import Button from '@/components/atoms/Button';

export default {
  name: 'NotFound',

  components: {
    Button,
  },

  data() {
    return {
      airMapUrl: `${window.location.origin}/${this.$route.params.lang}`,
      insideIframe: insideIframe(),
    };
  },

  methods: {
    goBack() {
      this.$router.push({ name: 'map' });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables";

.bg-gray-100 {
  background-image: url("../../assets/blebox_logo.svg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 90%;
  min-width: $minW;
}

.text-6xl {
  font-size: 8rem;
}
</style>
